/**
 * 底部标题 （legendPie使用）
 */
export function getBottomTitle(style, show: boolean = false, text: string = "") {
    let titleOption = {
        show: show,
        text: text,
        left: 'center',
        bottom: 0,
        textStyle: {
            fontWeight: 500,
            fontSize: style.fontSize,
        },

    }
    return titleOption;
}